import React, { ReactNode } from 'react'
import styled from '@emotion/styled'
import { e0Grey } from '../../colors'
import { theme } from '../../mui'

interface MetaAdPreviewProps {
  children: ReactNode
}

export const S = {
  Wrapper: styled.div`
    width: max-content;
  `,
  Preview: styled.div`
    position: relative;
    width: 20rem;
    height: 34rem;
    padding: 1rem;
    background-color: ${e0Grey};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.375em;
    font-size: 0.875rem;
    color: ${theme.palette.text.disabled};
  `,
}

const MetaAdPreviewWrapper = ({ children }: MetaAdPreviewProps) => {
  return <S.Preview>{children}</S.Preview>
}

export default MetaAdPreviewWrapper
